module.exports = __webpack_public_path__ + "static/media/crow_take_bite_roti.2c17db2a.png";